var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-7xl mx-auto sm:px-6 lg:px-8 my-10"},[_c('div',{staticClass:"rounded-md bg-white p-2"},[_c('full-calendar',{ref:"calendar",attrs:{"id":"calendarVue","options":_vm.calendarOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }